/* ==========================================================================
   Navigation 2026 (agood.com)
   Loaded by sections/header.liquid for the "Logo left, mega menu" layout.
   1. Mobile drawer: drill-down panels inside #NavDrawer   [data-nav26]
      (theme.Drawers in theme.js still opens and closes the drawer itself)
   2. Desktop bar: dropdown panels                          [data-nav26d]
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /* ---------- 1. Mobile drawer ---------- */
  var drawerNav = null; // the current drawer, replaced when the theme editor reloads the header

  function initDrawer(root) {
    var drawer = root.closest('.drawer');
    var rootPanel = root.querySelector('[data-nav26-root]');
    var heading = drawer.querySelector('[data-nav26-heading]');
    var backButton = drawer.querySelector('[data-nav26-back]');
    var backLabel = backButton.querySelector('[data-nav26-back-label]');
    var stack = []; // { panel, opener } for every open sub-panel

    function current() {
      return stack.length ? stack[stack.length - 1].panel : rootPanel;
    }

    function isOpen() {
      return drawer.classList.contains('drawer--is-open');
    }

    // The header shows "Menu" on the root panel and a back button on sub-panels
    function updateHeader() {
      var panel = current();
      var atRoot = panel === rootPanel;
      heading.hidden = !atRoot;
      backButton.hidden = atRoot;
      if (!atRoot) {
        backLabel.textContent = panel.getAttribute('data-nav26-back');
        backButton.setAttribute('aria-label', panel.getAttribute('data-nav26-back-a11y'));
      }
    }

    function show(next, opener) {
      var prev = current();
      prev.classList.remove('is-active');
      prev.classList.add('is-behind');
      next.scrollTop = 0;
      next.classList.add('is-active');
      opener.setAttribute('aria-expanded', 'true');
      stack.push({ panel: next, opener: opener });
      updateHeader();
      var title = next.querySelector('.nav26__title');
      if (title) title.focus({ preventScroll: true });
    }

    function back() {
      var top = stack.pop();
      if (!top) return;
      top.panel.classList.remove('is-active');
      top.opener.setAttribute('aria-expanded', 'false');
      var prev = current();
      prev.classList.remove('is-behind');
      prev.classList.add('is-active');
      updateHeader();
      top.opener.focus({ preventScroll: true });
    }

    function reset() {
      root.classList.add('is-resetting');
      while (stack.length) {
        var top = stack.pop();
        top.panel.classList.remove('is-active', 'is-behind');
        top.opener.setAttribute('aria-expanded', 'false');
      }
      rootPanel.classList.remove('is-behind');
      rootPanel.classList.add('is-active');
      rootPanel.scrollTop = 0;
      updateHeader();
      void root.offsetWidth; // apply the reset before transitions come back
      root.classList.remove('is-resetting');
    }

    // Tab and Shift+Tab stay inside the drawer header and the visible panel
    function trapTab(evt) {
      var panel = current();
      var items = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
        var owner = el.closest('[data-nav26-panel]');
        return (owner ? owner === panel : true) && !el.closest('[hidden]');
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      var target = null;
      if (evt.shiftKey && (active === first || active === drawer || !drawer.contains(active))) {
        target = last;
      } else if (!evt.shiftKey && active === last) {
        target = first;
      }
      if (target) {
        evt.preventDefault();
        evt.stopPropagation(); // keep theme.a11y.trapFocus from moving focus again
        target.focus();
      }
    }

    root.addEventListener('click', function (evt) {
      var opener = evt.target.closest('[data-nav26-open]');
      if (!opener) return;
      var next = document.getElementById(opener.getAttribute('data-nav26-open'));
      if (next) show(next, opener);
    });

    backButton.addEventListener('click', back);

    drawer.addEventListener('keydown', function (evt) {
      if (evt.key === 'Tab' && isOpen()) trapTab(evt);
    });

    // Return to the root panel once the drawer has closed
    if ('MutationObserver' in window) {
      var wasOpen = isOpen();
      new MutationObserver(function () {
        var open = isOpen();
        if (wasOpen && !open && stack.length) {
          window.setTimeout(function () {
            if (!isOpen()) reset();
          }, 400);
        }
        wasOpen = open;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    return {
      isOpen: isOpen,
      hasSubPanel: function () { return stack.length > 0; },
      back: back
    };
  }

  // While a sub-panel is open, Escape steps back one level. The theme must not
  // see that key press: theme.Drawers closes the drawer on keyup, and the
  // predictive search closes itself on any keydown, blurring the focus and
  // removing the html.js-drawer-open class.
  var escapeHandled = false;

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' || !drawerNav || !drawerNav.isOpen() || !drawerNav.hasSubPanel()) return;
    evt.stopPropagation();
    escapeHandled = true;
    drawerNav.back();
  }, true);

  document.addEventListener('keyup', function (evt) {
    if (evt.key !== 'Escape' || !escapeHandled) return;
    evt.stopPropagation();
    escapeHandled = false;
  }, true);

  /* ---------- 2. Desktop dropdowns ---------- */
  var OPEN_DELAY = 90;   // ms of hover before a panel opens while none is open
  var CLOSE_DELAY = 150; // ms grace period after the pointer leaves an item
  var openItem = null;    // the open item, shared by all bars
  var closingItem = null; // the item whose panel is fading out

  function initDesktopItem(item) {
    var trigger = item.querySelector('[data-nav26d-trigger]');
    var panel = item.querySelector('[data-nav26d-panel]');
    if (!trigger || !panel) return;

    var openTimer = null;
    var closeTimer = null;
    var openedBy = null; // 'hover' or 'click'
    var controller = { item: item, trigger: trigger, open: open, close: close, finishClose: finishClose };
    item.nav26 = controller;

    function isShown() {
      return !panel.hidden && !panel.classList.contains('is-closing');
    }

    function open(instant) {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      // Switching between items, also while the previous panel is still fading out: no fade
      if (closingItem && closingItem !== controller) {
        closingItem.finishClose();
        instant = true;
      }
      if (openItem && openItem !== controller) {
        openItem.close(true);
        instant = true;
      }
      if (panel.classList.contains('is-closing')) {
        // Back before the fade-out ended: keep the panel where it is
        panel.classList.remove('is-closing');
        if (closingItem === controller) closingItem = null;
      } else if (!panel.hidden) {
        return;
      } else {
        panel.classList.toggle('is-instant', Boolean(instant));
        panel.hidden = false;
      }
      trigger.setAttribute('aria-expanded', 'true');
      item.classList.add('is-open');
      openItem = controller;
    }

    // Fades the panel out (the fade-in reversed); instant hides it at once
    function close(instant) {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      openedBy = null;
      if (panel.hidden) return;
      if (panel.classList.contains('is-closing')) {
        if (instant) finishClose();
        return;
      }
      trigger.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');
      if (openItem === controller) openItem = null;

      if (instant) {
        panel.hidden = true;
        return;
      }
      panel.classList.add('is-closing');
      // No animation with reduced motion or the theme's animations turned off
      if (window.getComputedStyle(panel).animationName === 'none') {
        finishClose();
        return;
      }
      closingItem = controller;
      panel.addEventListener('animationend', function onEnd(evt) {
        if (evt.target !== panel) return;
        panel.removeEventListener('animationend', onEnd);
        if (panel.classList.contains('is-closing')) finishClose();
      });
    }

    function finishClose() {
      panel.classList.remove('is-closing');
      panel.hidden = true;
      if (closingItem === controller) closingItem = null;
    }

    item.addEventListener('pointerenter', function (evt) {
      if (evt.pointerType !== 'mouse') return;
      window.clearTimeout(closeTimer);
      if (isShown()) return;
      if (openItem || closingItem) {
        open();
        openedBy = 'hover';
      } else {
        openTimer = window.setTimeout(function () {
          open();
          openedBy = 'hover';
        }, OPEN_DELAY);
      }
    });

    item.addEventListener('pointerleave', function (evt) {
      if (evt.pointerType !== 'mouse') return;
      window.clearTimeout(openTimer);
      if (isShown()) closeTimer = window.setTimeout(close, CLOSE_DELAY);
    });

    // The first click on a panel that hover just opened keeps it open
    trigger.addEventListener('click', function () {
      if (!isShown()) {
        open();
        openedBy = 'click';
      } else if (openedBy === 'hover') {
        openedBy = 'click';
      } else {
        close();
      }
    });

    item.addEventListener('focusout', function (evt) {
      if (!isShown()) return;
      var to = evt.relatedTarget;
      if (to && item.contains(to)) return;
      if (!to && item.matches(':hover')) return; // a click on empty space in the panel
      close();
    });
  }

  document.addEventListener('click', function (evt) {
    if (openItem && !openItem.item.contains(evt.target)) openItem.close();
  });

  // Capture phase, so the predictive search's Escape handler can't blur the focus first
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' || !openItem) return;
    evt.stopPropagation();
    var item = openItem;
    var hadFocus = item.item.contains(document.activeElement);
    item.close();
    if (hadFocus) item.trigger.focus();
  }, true);

  // Theme editor: show the panel of the selected "Navigation panel extras" block
  document.addEventListener('shopify:block:select', function (evt) {
    var item = evt.target.closest && evt.target.closest('[data-nav26d-item]');
    if (item && item.nav26) item.nav26.open(true);
  });

  document.addEventListener('shopify:block:deselect', function (evt) {
    var item = evt.target.closest && evt.target.closest('[data-nav26d-item]');
    if (item && item.nav26) item.nav26.close();
  });

  /* ---------- 3. Menu bar fit ---------- */
  // A long menu or a translation may not fit next to the logo. The bar then
  // first tries the smaller text size (.nav26-tight); if it still doesn't fit,
  // the header keeps the menu button layout (.nav26-compact) at that width.
  var MIN_GAP = 24; // px of free space the bar needs between the logo and "For business"

  function fitBar() {
    var header = document.querySelector('.site-header--nav-2026');
    var nav = header && header.querySelector('.nav26-header__nav');
    var bar = nav && nav.querySelector('.nav26d__bar');
    if (!bar) return;
    header.classList.remove('nav26-tight', 'nav26-compact');
    if (getComputedStyle(nav).display === 'none') return; // below the desktop breakpoint
    var fits = function () { return bar.offsetWidth + MIN_GAP <= nav.clientWidth; };
    if (fits()) return;
    header.classList.add('nav26-tight');
    if (fits()) return;
    header.classList.add('nav26-compact');
    if (openItem) openItem.close();
  }

  var fitFrame = null;
  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(fitFrame);
    fitFrame = window.requestAnimationFrame(fitBar);
  });

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitBar);

  /* ---------- Init ---------- */
  function init() {
    fitBar();

    var root = document.querySelector('#NavDrawer [data-nav26]');
    if (root && !root.dataset.nav26Ready) {
      root.dataset.nav26Ready = 'true';
      drawerNav = initDrawer(root);
    }

    document.querySelectorAll('[data-nav26d] [data-nav26d-item]').forEach(function (item) {
      if (item.dataset.nav26Ready) return;
      item.dataset.nav26Ready = 'true';
      initDesktopItem(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: the header section was re-rendered
  document.addEventListener('shopify:section:load', function () {
    openItem = null;
    init();
  });
})();
